import { useState } from "@wordpress/element";
import CircularProgress from "@mui/material/CircularProgress";
import clsx from "clsx";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import * as yup from "yup";
import InputAdornment from "@mui/material/InputAdornment";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch } from "react-redux";
import { TextField } from "vino/core";
import { connectStore } from "admin/store/storeSlice";

const schema = yup.object().shape({
	email: yup
		.string()
		.email("Please enter a valid email")
		.required("Please enter a email"),
	password: yup.string().required("Please enter your password."),
});

const defaultValues = {
	email: "",
	password: "",
};

const ConnectAccount = ({ store }) => {
	const dispatch = useDispatch();

	const methods = useForm({
		mode: "onChange",
		defaultValues,
		resolver: yupResolver(schema),
	});
	const { handleSubmit } = methods;

	const [showPassword, setShowPassword] = useState(false);

	function onSubmit(model) {
		dispatch(connectStore(model));
	}

	return (
		<FormProvider {...methods}>
			<form
				noValidate
				className="flex flex-col justify-center w-full"
				onSubmit={handleSubmit(onSubmit)}
			>
				<div className="mb-16">
					<TextField
						name="email"
						type="text"
						label="Email"
						fullWidth
						required
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<Icon className="fa-solid fa-user text-20" color="action" />
								</InputAdornment>
							),
						}}
						variant="outlined"
					/>
				</div>
				<div>
					<TextField
						name="password"
						label="Password"
						type="password"
						variant="outlined"
						fullWidth
						InputProps={{
							className: "pr-2",
							type: showPassword ? "text" : "password",
							endAdornment: (
								<InputAdornment position="end">
									<Icon
										onClick={() => setShowPassword(!showPassword)}
										className={clsx(
											"cursor-pointer text-20 fa-solid",
											showPassword ? "fa-eye" : "fa-eye-slash"
										)}
										color="action"
									/>
								</InputAdornment>
							),
						}}
						required
					/>
				</div>
				{store.error && (
					<div className="mt-16">
						<Typography color="red">The login detail is incorrect</Typography>
					</div>
				)}
				<div className="flex mt-16">
					<Button
						type="submit"
						variant="contained"
						color="success"
						disabled={store.isSubmitting}
						className="px-30 py-10"
					>
						{store.isSubmitting && (
							<CircularProgress color="inherit" size={25} />
						)}
						Connect
					</Button>
				</div>
			</form>
		</FormProvider>
	);
};

export default ConnectAccount;
